/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable no-unused-vars */
export enum ATHENA_LENDING_PRODUCT {
  OWNER_PI_VARIABLE = 'Owner P&I Variable',
  OWNER_IO_VARIABLE = 'Owner IO Variable',
  INVESTOR_PI_VARIABLE = 'Investor P&I Variable',
  INVESTOR_IO_VARIABLE = 'Investor IO Variable',
}
